export const carouselImages = [
	"https://www.decathlon.in/_next/image?url=https%3A%2F%2Fcontents.mediadecathlon.com%2Fs853980%2Fk%2474855d9d9d5920b0ca50640b2b758e7c%2Fmain%2520banners%2520galaxy%2520to%2520galaxy%2520main%2520banner%2520desktop.jpg%3Ff%3D1920x470%26format%3Dauto&w=1920&q=75",
	"https://www.decathlon.in/_next/image?url=https%3A%2F%2Fcontents.mediadecathlon.com%2Fs852987%2Fk%24691bebc336b1cd65269cbce701dc602d%2Fmain%2520banners%2520ipl%2520banner%2520desktop%2520category.jpg%3Ff%3D1920x470%26format%3Dauto&w=1920&q=75",
	"https://www.decathlon.in/_next/image?url=https%3A%2F%2Fcontents.mediadecathlon.com%2Fs852993%2Fk%243a07031933636d8ee1bc89fea10e292c%2Fmain%2520banners%2520ipl%2520banner%2520desktop%2520category.jpg%3Ff%3D1920x470%26format%3Dauto&w=1920&q=75",
];

export const LOAD__PRODUCTS = "LOAD__PRODUCTS";
export const LOAD__CATEGORIES = "LOAD__CATEGORIES";
export const ADD__OR__REMOVE__ITEM__FROM__WISHLIST = "ADD__OR__REMOVE__ITEM__FROM__WISHLIST";
export const ADD__OR__REMOVE__ITEM__FROM__CART = "ADD__OR__REMOVE__ITEM__FROM__CART";
export const INCREMENT__OR__DECREMENT__QUANTITY = "INCREMENT__OR__DECREMENT__QUANTITY";
export const PRICE__LOW__TO__HIGH = "PRICE__LOW__TO__HIGH";
export const PRICE__HIGH__TO__LOW = "PRICE__HIGH__TO__LOW";
export const INCLUDE__OUT__OF__STOCK = "INCLUDE__OUT__OF__STOCK";
export const INCLUDE__FAST__DELIVERY = "INCLUDE__FAST__DELIVERY";
export const CLEAR__FILTERS = "CLEAR__FILTERS";
export const SET__LOADING = "SET__LOADING";
export const SET__LOGIN = "SET__LOGIN";
export const SET__LOGOUT = "SET__LOGOUT";
export const SET__SIGNUP = "SET__SIGNUP";
export const LOAD__USER = "LOAD__USER";
export const SET__SEARCH__TEXT = "SET__SEARCH__TEXT";
export const SET_PAID = "SET_PAID";
export const SHOW_FILTERS = "SHOW_FILTERS";
